export const AuctionTypes = {
  SET_SELECTED_VARIETIES: "SET_SELECTED_VARIETIES",
  SET_SELECTED_HUBS: "SET_SELECTED_HUBS",
  SET_SELECTED_CLAIMS: "SET_SELECTED_CLAIMS",
  SET_SELECTED_CROP: "SET_SELECTED_CROP",
  SET_START_DATE: "SET_START_DATE",
  SET_END_DATE: "SET_END_DATE",
  SET_SOCKET: "SET_SOCKET",
  SET_ACTIVE_AUCTION: "SET_ACTIVE_AUCTION",
  SET_UPCOMING_AUCTION: "SET_UPCOMING_AUCTION",
  SET_BIDS_EVENT: "SET_BIDS_EVENT",
  SET_WINS_EVENT: "SET_WINS_EVENT",
  RESET_AUCTION_DATA: "RESET_AUCTION_DATA",
  SET_REBATE_AGREEMENT: "SET_REBATE_AGREEMENT",
  SET_COUNT_EVENT: "SET_COUNT_EVENT",
  SET_TC_AGREEMENT: "SET_TC_AGREEMENT",
  SET_REPORT_EVENT: "SET_REPORT_EVENT",
};
